export default __webpack_public_path__ + "static/media/Button.77cc2d37.png";